// Global Instructions Rule Applied!

import React, { forwardRef } from 'react'
import { TimePicker } from 'antd'
import { InputSize } from '../types.ts'
import dayjs, { Dayjs } from 'dayjs'

export interface TimeInputProps {
  value: any
  onChange: (value: any) => void
  onKeyDown?: (e: React.KeyboardEvent) => void
  size?: InputSize
  placeholder?: string
  format?: string
  allowClear?: boolean
  status?: 'error' | 'warning'
  autoFocus?: boolean
}

export const TimeInput = forwardRef<any, TimeInputProps>(
  (
    {
      value,
      onChange,
      onKeyDown,
      size = 'small',
      placeholder,
      format = 'HH:mm:ss',
      allowClear = true,
      status,
      autoFocus
    },
    ref
  ) => {
    const handleChange = (time: Dayjs | null, timeString: string | string[]) => {
      if (time) {
        onChange(time.format(format))
      } else {
        onChange(null)
      }
    }

    const dayjsValue = value ? dayjs(value, format) : null

    return (
      <TimePicker
        ref={ref}
        value={dayjsValue}
        onChange={handleChange}
        size={size}
        format={format}
        allowClear={allowClear}
        placeholder={placeholder}
        status={status}
        style={{ width: '100%' }}
        onKeyDown={onKeyDown}
        autoFocus={autoFocus}
      />
    )
  }
)

TimeInput.displayName = 'TimeInput'
